import layout from 'layouts/default'
import datatable from 'components/datatable'
import moment from 'moment'

const components = {
  layout,
  datatable
}

const methods = {
  formatDate (value) {
    if (!value) return '-'
    const date = moment(value)
    return date.isValid() ? date.format('MM/DD/YYYY hh:mm A') : value
  },

  formatLabel (value) {
    if (!value) return '-'
    return String(value)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (letter) => letter.toUpperCase())
  },

  search () {
    this.filters._q = this.searchKey
    this.reload()
  },

  reload () {
    this.$nextTick(() => {
      this.$refs.table.loadPage(1)
    })
  },

  setCols () {
    this.columns = [
      {name: 'Reservation #', object_name: 'reservation_number', sortable: true, sort_key: 'reservation_number'},
      {name: 'Action', object_name: (row) => this.formatLabel(row.action_type), sortable: true, sort_key: 'action_type'},
      {name: 'Location', object_name: (row) => this.display(row.location_name)},
      {name: 'Channel', object_name: (row) => this.display(row.channel_name)},
      {name: 'Customer', object_name: (row) => this.display(row.reserved_for)},
      {name: 'Email', object_name: (row) => this.display(row.email)},
      {name: 'Grand Total', object_name: (row) => this.display(row.grand_total)},
      {name: 'Reservation Created', object_name: (row) => this.formatDate(row.reservation_created_at)},
      {name: 'Action Date', object_name: (row) => this.formatDate(row.action_date), sortable: true, sort_key: 'action_date'},
      {
        name: 'View',
        object_name: () => '<i class="fa fa-eye" aria-hidden="true"></i>',
        classes: ['clickable'],
        click: (row) => {
          this.$router.push({
            name: 'reservationActions.details',
            params: {id: row.id}
          })
        }
      }
    ]
  },

  display (value) {
    return value !== null && value !== undefined && value !== '' ? value : '-'
  }
}

export default {
  name: 'all-reservation-actions',
  components,
  methods,
  data () {
    return {
      searchKey: '',
      filters: {
        _q: '',
        action_type: ''
      },
      columns: []
    }
  },
  created () {
    this.setCols()
  }
}
